<script setup lang="ts">
const { state } = useAppStore()
const localePath = useLocalePath()
const legal: any[] = ['privacy', 'terms']
</script>

<template>
    <footer class="mt-32 py-20 bg-chsc-indigo-500">
        <UContainer class="max-w-2xl">
            <div class="flex flex-col items-center">
                <NuxtLink :to="localePath('/')">
                    <img
                        src="https://a.storyblok.com/f/331854/77x120/b11bb871b9/chocolate-scorecard-imago.svg"
                        alt="Chocolate Scorecard"
                    >
                </NuxtLink>
            </div>
        </UContainer>
        <UContainer>
            <ul class="flex items-center justify-center gap-6 mt-6 max-[769px]:flex-col max-[769px]:gap-2">
                <li
                    v-for="item in state.menu"
                    :key="item._uid"
                    class="flex items-center gap-6 after:content-[''] after:block after:w-[3px] after:h-[3px] after:bg-white after:rounded-full last:after:hidden max-[769px]:after:hidden"
                >
                    <NuxtLink
                        :to="localePath(`/${item.url}`)"
                        class="fs-xs font-monsterrat font-bold uppercase text-white hover:opacity-90"
                    >
                        <span>{{ item.label }}</span>
                    </NuxtLink>
                </li>
            </ul>
        </UContainer>
        <UContainer class="max-w-2xl">
            <p class="mt-6 fs-base text-white text-center">
                {{ useText(state.strings, 'app_footer') }}
            </p>
            <ul class="flex items-center justify-center gap-6 mt-6 max-[769px]:flex-col max-[769px]:gap-2">
                <li
                    v-for="item in state.legal"
                    :key="item"
                >
                    <a
                        :href="item.url"
                        target="_blank"
                        class="fs-xs font-monsterrat font-bold uppercase text-white hover:opacity-90"
                    >
                        {{ item.label }}
                    </a>
                </li>
            </ul>
        </UContainer>
    </footer>
</template>
